import { render, staticRenderFns } from "./ccc-por-vendedor.vue?vue&type=template&id=0a508c8a&scoped=true"
import script from "./ccc-por-vendedor.vue?vue&type=script&lang=js"
export * from "./ccc-por-vendedor.vue?vue&type=script&lang=js"
import style0 from "./ccc-por-vendedor.vue?vue&type=style&index=0&id=0a508c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a508c8a",
  null
  
)

export default component.exports